export default __webpack_public_path__ + "static/media/bb_Commision.e944a071.svg";